import React, { useEffect } from "react";

type Props = {};

const CookiesComponent = (props: Props) => {
    // useEffect(() => {
    //     const script = document.createElement("script");
    //     script.src = "https://policy.cookiereports.com/e8d11e26_panel-en-gb.js";
    //     script.async = true;
    //     script.onload = () => {
    //         console.log("Script loaded successfully");
    //     };
    //     script.onerror = () => {
    //         console.error("Error loading script");
    //     };
    //     document.body.appendChild(script);
    //     return () => {
    //         document.body.removeChild(script);
    //     };
    // }, []);

    useEffect(()=>{
        const headScript = document.createElement("script");
        headScript.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                            })(window,document,'script','dataLayer','GTM-KW9S88VG')`
        document.head.appendChild(headScript);

        const noscriptElement = document.createElement("noscript");
        const iframeElement = document.createElement("iframe");
        iframeElement.src = "https://www.googletagmanager.com/ns.html?id=GTM-KW9S88VG"
        iframeElement.height = "0";
        iframeElement.width = "0";
        iframeElement.style.display = "none";
        iframeElement.style.visibility = "hidden";
        noscriptElement.appendChild(iframeElement);
        document.body.appendChild(noscriptElement);
        
    },[])
    return <></>;
};

export default CookiesComponent;
